import React , {useEffect} from 'react';
import Header from './components/Shared/Header';
import Footer from './components/Shared/Footer';
import {connect, setStore} from 'trim-redux';
import 'bootstrap/dist/css/bootstrap.min.css';
import Login from "./components/login/Login";
//import Failed from './components/login/Failed';
//import Confirmation from "./components/login/Confirmation";
import {Helmet} from "react-helmet";
import Modal from "./components/Modal";
import {suppInfo} from "./Actions";

function App({failed , paymentToken , showModalErr , serverErr ,loading , isFailed , ManySmsReq}){
    useEffect(() => {
        localStorage.clear();
        const pathname = window.location.pathname.split('/')[1];
        suppInfo(pathname);
    },[]);
    function closeErrBox() {
        setStore({
            showModalErr: false
        })
    }
  return (
      <div className="App">
          <Helmet>
              <meta charSet="utf-8" />
              <title>درگاه پرداخت اعتباری کیپا </title>
          </Helmet>
          <Header/>
          <Modal show={showModalErr}>
              {
                  serverErr ?
                      (<div>
                          <p className='modal-title' style={{textAlign: 'center'}}>.در برقراری ارتباط با سوییچ اعتباری کیپا خطایی رخ داده است</p>
                          <p className='modalErr-desc'>
                              .لطفا پس از ده دقیقه مجددا اقدام نمائید و در صورت تکرار خطا، با پشتیبانی کیپا تماس حاصل فرمائید
                          </p>
                      </div>)
                          :
                      ManySmsReq ?
                          (  <div>
                              <p className='modal-title' style={{textAlign: 'center'}}>تعداد درخواست ارسال مجدد کد فعالسازی بیش از حد مجاز است</p>
                              <p className='modalErr-desc'>
                                  در صورت تمایل با پشتیبانی کیپا تماس حاصل فرمائید
                              </p>
                          </div>)
                          :
                          (<div>
                              <p className='modal-title' style={{textAlign: 'center'}}>در انجام فرآیند پرداخت خطایی رخ داده است</p>
                              <p className='modalErr-desc'>
                                  در صورت مشاهده این خطا، جهت تکرار خرید به ابتدای فرآیند پرداخت منتقل خواهید شد. خواهشمند است در هر مرحله از فرآیند پرداخت برای بازگشت به مراحل قبل تنها از دکمه “بازگشت” استفاده فرمائید
                              </p>
                          </div>)
              }
              {
                  ManySmsReq ? (<div className="modal-actions" style={{marginRight: 0, justifyContent: 'center'}}>
                
                          <button className='backToSupp-btn' onClick={closeErrBox} style={{width: 300}}>
                              بستن
                          </button>
                      </div>)
                      :
                      <div className="modal-actions" style={{marginRight: 0, justifyContent: 'center'}}>
                          <form action={localStorage.callBackUrl} method="post" name='redirectToSupplier'>
                              <input name="reciept_number" value="" hidden/>
                              <input name="payment_token" value={paymentToken} hidden/>
                              <input name="state" value="101" hidden/>
                              <input name="msg" value="عملیات ناموفق بود" hidden/>
                              <button className='backToSupp-btn' type="submit" style={{width: 300}}>
                                  بازگشت به سایت پذیرنده
                              </button>
                          </form>
                      </div>
              }
          </Modal>
          <Login/>
          <Footer/>
      </div>
  );
}
const mstp = state => ({
    loading: state.loading,
    paymentToken: state.paymentToken,
    showModalErr: state.showModalErr,
    serverErr: state.serverErr,
    ManySmsReq: state.ManySmsReq
});
export default connect(mstp)(App);
